import { withRouter } from 'react-router-dom';
import Error from 'Components/Error';
import Grid from '@material-ui/core/Grid';
import Loader from 'Components/Loader';
import React from 'react';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';

// import 'CSS/dashboard-tickets.scss';
import 'CSS/dashboard-tickets.scss';

import API from '../../../../api';
import SidebarMachine from './stateMachine';
import SidebarTicket from './components/SidebarTicketCard';

class SidebarTickets extends React.Component {
  state = {
    value: 0,
    isLoading: false,
    error: null,
    favoriteTickets: [],
    suggestedTickets: [],
    viewState: SidebarMachine.initialState.value,
  };

  componentDidMount() {
    this.getFavoriteTickets();
  }

  componentDidUpdate(prevProps) {
    if (!this.props.projectId || prevProps.projectId !== this.props.projectId) {
      this.getFavoriteTickets();
    }
    if (!this.props.internal || prevProps.internal !== this.props.internal) {
      this.getSuggestedTickets();
    }
  }

  getFavoriteTickets = () => {
    if (!this.props.projectId) return;
    API.getFavoriteTickets(this.props.projectId)
      .then(res => {
        this.setState(state => ({
          viewState: SidebarMachine.transition(state.viewState, 'TICKETS'),
          favoriteTickets: res.data,
        }));
      })
      .catch(error => {
        this.setState(state => ({
          error,
          viewState: SidebarMachine.transition(state.viewState, 'ERROR'),
        }));
      });
  };

  getSuggestedTickets = () => {
    if (!this.props.internal) return;
    API.getSuggestedTickets(this.props.internal)
      .then(res => {
        this.setState(state => ({
          viewState: SidebarMachine.transition(state.viewState, 'TICKETS'),
          suggestedTickets: res.data,
          value: 1,
        }));
      })
      .catch(error => {
        this.setState(state => ({
          error,
          viewState: SidebarMachine.transition(state.viewState, 'ERROR'),
        }));
      });
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  onErrorCancel = () => {
    this.setState(state => ({
      error: null,
      viewState: SidebarMachine.transition(state.viewState, 'CANCEL'),
    }));
  };

  render() {
    const { value } = this.state;
    return (
      <Grid container alignItems={'center'} justify={'center'}>
        <Grid item xs={11}>
          <Tabs value={value} onChange={this.handleChange}>
            <Tab
              className="t-secondary-18 t-weight-b sidebar-tab"
              label="Favourite searches"
            />
            <Tab
              className="t-secondary-18 t-weight-b sidebar-tab"
              label="Suggested searches"
            />
          </Tabs>
        </Grid>
        <Grid item xs={12} className="scrollable-area tickets-scroll">
          {/* <ScrollArea
            speed={0.8}
            className="area sidebar-scrollarea scrolable-sidebar-tickets"
            contentClassName="content"
            horizontal={false}
          > */}
          {this.state.viewState === 'loading' ? <Loader isLoading /> : null}
          {this.state.value === 'error' ? (
            <Error errors={this.state.error} onCancel={this.onErrorCancel} />
          ) : null}
          <div className="u-mrg-top-40">
            {value === 0 && (
              <div className="favoriteTickets">
                {this.state.favoriteTickets.length > 0
                  ? this.state.favoriteTickets.map(ticket => (
                      <SidebarTicket
                        {...this.props}
                        key={ticket.ticketId}
                        ticket={ticket}
                      />
                    ))
                  : null}
              </div>
            )}
            {value === 1 && (
              <div className="favoriteTickets">
                <p className="t-primary-14 lh-20 u-pad-l-30 u-pad-r-30 u-mrg-bot-20">
                  Suggested searches to use based on your project application
                  and criteria
                </p>
                {this.state.suggestedTickets.length > 0
                  ? this.state.suggestedTickets.map(ticket => (
                      <SidebarTicket
                        key={ticket.ticketId}
                        ticket={ticket}
                        {...this.props}
                      />
                    ))
                  : null}
              </div>
            )}
          </div>
          {/* </ScrollArea> */}
        </Grid>
      </Grid>
    );
  }
}
export default withRouter(SidebarTickets);
